import { CoAppActionButton } from "../../styled/global.styled";

/**
 * @param {{ icon?: import("react").ReactNode, onClick?: import("react").MouseEventHandler<HTMLButtonElement>, text: string }}
 */
interface CoAppIconActionButtonProps {
	icon?: React.ReactNode;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	text: string;
}

export default function CoAppIconActionButton({ icon = null, onClick, text }: CoAppIconActionButtonProps) {
	if (icon) {
		return (
			<CoAppActionButton onClick={onClick}>
				{icon}
				{text}
			</CoAppActionButton>
		);
	} else {
		return (
			<CoAppActionButton onClick={onClick}>
				{text}
			</CoAppActionButton>
		);
	}
}
